import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Trimester } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<Trimester> {

	return {
		rowName: { singular: 'Trimester', plural: 'Trimesters' },
		getRowKey: row => '' + row.trimesterId,
		stateKey: 'follow-ups-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
